import React from 'react'

export const AlertIcon = () => (
  <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M22.2517 9.14697C23.0137 7.77535 24.9863 7.77535 25.7483 9.14697L42.3493 39.0287C43.0899 40.3618 42.1259 42 40.601 42H7.39903C5.87406 42 4.91012 40.3618 5.65071 39.0287L22.2517 9.14697Z'
      fill='#F80000'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M24 38C25.1046 38 26 37.1046 26 36C26 34.8954 25.1046 34 24 34C22.8954 34 22 34.8954 22 36C22 37.1046 22.8954 38 24 38Z'
      fill='#EFF3F4'
    />
    <path d='M24 20V30' stroke='white' stroke-width='2' stroke-linecap='round' />
  </svg>
)
